/* VTILTED footer order email copy button */
(function () {
  'use strict';

  var EMAIL = 'vtiltedapparel@gmail.com';
  var STYLE_ID = 'vt-footer-email-copy-style';

  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.vt-footer-orders-link{cursor:default!important;}',
      '.vt-footer-orders-link__text{flex:1 1 auto!important;min-width:0!important;text-decoration:none!important;font-size:16px!important;line-height:1.2!important;letter-spacing:-.01em!important;white-space:nowrap!important;word-break:normal!important;overflow-wrap:normal!important;}',
      '.vt-footer-orders-copy{display:inline-flex!important;align-items:center!important;justify-content:center!important;flex:0 0 auto!important;min-width:78px!important;height:42px!important;padding:0 14px!important;margin:0!important;border:1px solid #111!important;background:transparent!important;color:#111!important;-webkit-text-fill-color:#111!important;border-radius:0!important;box-shadow:none!important;font:700 12px/1 Arial,sans-serif!important;letter-spacing:.08em!important;text-transform:uppercase!important;cursor:pointer!important;transition:background .18s ease,color .18s ease!important;}',
      '.vt-footer-orders-copy:hover,.vt-footer-orders-copy:focus-visible,.vt-footer-orders-copy.is-copied{background:#111!important;color:#fff!important;-webkit-text-fill-color:#fff!important;outline:none!important;}',
      '.vt-footer-orders-copy:focus-visible{outline:2px solid #111!important;outline-offset:3px!important;}',
      '@media(max-width:767px){.vt-footer-orders-link{gap:10px!important;}.vt-footer-orders-link__text{font-size:13px!important;line-height:1.2!important;white-space:nowrap!important;}.vt-footer-orders-copy{min-width:60px!important;height:38px!important;padding:0 9px!important;font-size:10px!important;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function showCopied(button) {
    var label = button.querySelector('[data-vt-copy-label]');
    button.classList.add('is-copied');
    if (label) label.textContent = 'COPIED';
    window.clearTimeout(button.__vtCopyTimer);
    button.__vtCopyTimer = window.setTimeout(function () {
      button.classList.remove('is-copied');
      if (label) label.textContent = 'COPY';
    }, 1600);
  }

  function fallbackCopy(button) {
    var textarea = document.createElement('textarea');
    textarea.value = EMAIL;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    textarea.setSelectionRange(0, textarea.value.length);
    try {
      if (document.execCommand('copy')) showCopied(button);
    } catch (err) {}
    document.body.removeChild(textarea);
  }

  function copyEmail(button) {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(EMAIL).then(function () {
        showCopied(button);
      }).catch(function () {
        fallbackCopy(button);
      });
    } else {
      fallbackCopy(button);
    }
  }

  function markEmailText(row) {
    var textEl = null;
    var candidates = row.querySelectorAll('span,p,strong,div');
    for (var i = 0; i < candidates.length; i++) {
      var text = (candidates[i].textContent || '').replace(/\s+/g, '').toLowerCase();
      if (text === EMAIL.toLowerCase()) {
        textEl = candidates[i];
        break;
      }
    }

    if (!textEl) {
      for (var j = 0; j < row.childNodes.length; j++) {
        var node = row.childNodes[j];
        if (node.nodeType === 3 && (node.textContent || '').indexOf(EMAIL) > -1) {
          var span = document.createElement('span');
          span.textContent = EMAIL;
          row.replaceChild(span, node);
          textEl = span;
          break;
        }
      }
    }

    if (textEl) textEl.classList.add('vt-footer-orders-link__text');
  }

  function initFooterEmailCopy() {
    addStyles();
    document.querySelectorAll('.vt-footer-orders-link').forEach(function (row) {
      markEmailText(row);
      if (row.getAttribute('data-vt-copy-ready') === '1') return;

      if (row.tagName && row.tagName.toLowerCase() === 'a') {
        row.removeAttribute('href');
        row.removeAttribute('target');
        row.removeAttribute('rel');
      }
      row.setAttribute('role', 'group');
      row.setAttribute('aria-label', 'VTILTED order email');
      row.setAttribute('data-vt-copy-ready', '1');

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'vt-footer-orders-copy';
      button.setAttribute('data-vt-email-copy', '');
      button.setAttribute('aria-label', 'Copy VTILTED email address');
      button.innerHTML = '<span data-vt-copy-label>COPY</span>';
      row.appendChild(button);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-vt-email-copy]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    copyEmail(button);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterEmailCopy);
  } else {
    initFooterEmailCopy();
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(initFooterEmailCopy, 0);
  });
})();
